<div class="header-fixed menubar-pin parent-container">
    <div id="base">
        <div class="super-container">
            <div class="page-loader-container" *ngIf="isPageLoading">
                <app-new-loader></app-new-loader>
            </div>
            <section *ngIf="!isPageLoading">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="text-primary page-heading"> {{'titleTxt' | translate }}</h2>
                    </div>
                    <div class="col-lg-6">
                        <article class="margin-bottom-xxl">
                            <p class="lead page-sub-heading">
                                {{'subHeadingTxt' | translate }}
                            </p>
                        </article>
                    </div>
                </div>
                <div class="section-body">
                    <div class="content-container">
                        <div class="">
                            <div class="tab-pane active" id="first1">
                                <h3 class="filter-heading-text">
                                    {{'paragraphText' | translate }}
                                    <span>
                                        <select class="academic-year-dropdown" id="academicYearSelect"
                                            [(ngModel)]="selectedYearId" (change)="onSelectionChange()">
                                            <option *ngFor="let year of academicYears" [value]="year.pkAcademicId">
                                                {{ year.Year }}
                                                <span *ngIf="year.isCurrentAcademic">
                                                    {{'currentYearText' | translate }}
                                                </span>
                                            </option>
                                        </select>
                                    </span>
                                </h3>
                                <form class="create-filter-container" autocomplete="off">
                                    <div>
                                        <h4 class="filter-broadcast-text">{{'filterText' | translate }} :</h4>
                                    </div>
                                    <div>
                                        <select id="groups-category" name="select13"
                                            class="form-control filter-dropdown" [(ngModel)]="selectedReceiverId"
                                            (change)="onSelectionChange()">
                                            <option [value]="''" disabled>
                                                {{'AddFilterText' | translate }}
                                            </option>
                                            <option *ngFor="let receiver of broadcastReceivers"
                                                [value]="receiver.receiverId">
                                                {{ receiver.receiver }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <div *ngIf="permissions.CREATE_BROADCAST == 'ENABLED' && createButtonVisible">
                                            <button type="button" (click)="openPopup()"
                                                class="btn btn-raised ink-reaction btn-info create-broadcast-btn"
                                                aria-expanded="false">
                                                {{'createText' | translate }}</button>
                                        </div>
                                    </div>
                                    <div class="remove-filter-btn-container">
                                        <button *ngIf="selectedReceiverId!=''" (click)="removeFilter()"
                                            class="remove-filter-btn">
                                            {{'removeFilter' | translate }}
                                        </button>
                                    </div>
                                </form>
                                <div class="table-pagination-container">
                                    <div class="table-responsive">
                                        <table id="groups-student-list" class="table table-striped" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th class="table-row-text-center">{{'srNoText' | translate }}</th>
                                                    <th>{{'broadcastNameText' | translate }}</th>
                                                    <th>{{'broadcastDescText' | translate }}</th>
                                                    <th class="table-row-text-center">{{'broadcastTypeCol' | translate }}</th>
                                                    <th class="table-row-text-center">{{'broadcastPriority' | translate }}</th>
                                                    <th class="table-row-text-center">{{'broadcastDate' | translate }}</th>
                                                    <th class="table-row-text-center">{{'previewText' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngIf="broadcastData.length===0">
                                                    <td class="no-data-available-row" colspan="7">
                                                        {{'noDataDisplay' | translate }}
                                                    </td>
                                                </tr>
                                                <tr *ngFor="let broadcast of broadcastData; let i = index">
                                                    <td class="table-body-row">{{ getSerialNumber(i) }}</td>
                                                    <td>{{ broadcast.broadcastSubject }}
                                                    </td>
                                                    <td>{{ broadcast.broadcastMessage }}
                                                    </td>
                                                    <td class="table-body-row">
                                                        {{
                                                        broadcast.broadcastReceiver
                                                        }}
                                                    </td>
                                                    <td class="table-body-row">
                                                        <span *ngIf="broadcast.isHighPriority; else noStar">
                                                            {{'highText' | translate }}
                                                        </span>
                                                        <ng-template #noStar>{{'lowText' | translate }}</ng-template>
                                                    </td>
                                                    <td class="table-body-row">
                                                        {{
                                                        broadcast.approvedTime
                                                        +
                                                        ", "
                                                        +
                                                        broadcast.
                                                        approvedDate
                                                        +
                                                        ", "
                                                        +
                                                        broadcast.
                                                        approvedYear
                                                        }}
                                                    </td>
                                                    <td class="preview-table-col table-body-row">
                                                        <span *ngIf="broadcast.broadcastMediaList?.length"
                                                            (click)="openMediaPreviewPopup(broadcast.broadcastMediaList)">{{'previewLabel' | translate }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav>
                                        <ul class="paginate-container">
                                            <li class="page-item">
                                                <button (click)="goToPreviousPage()" class="page-link"
                                                    [disabled]="currentPage === 1">
                                                    {{'paginatePrevious' | translate }}
                                                </button>
                                            </li>
                                            <ng-container *ngFor="let page of visiblePages">
                                                <li class="page-item">
                                                    <ng-container *ngIf="page === 0; else pageButtonTemplate">
                                                        <span class="ellipsis">{{'ellipsis' | translate }}</span>
                                                    </ng-container>
                                                    <ng-template #pageButtonTemplate>
                                                        <button class="page-link" (click)="goToPage(page)"
                                                            [class.active]="currentPage === page">
                                                            {{ page }}
                                                        </button>
                                                    </ng-template>
                                                </li>
                                            </ng-container>
                                            <li class="page-item">
                                                <button (click)="goToNextPage()" class="page-link"
                                                    [disabled]="currentPage === totalPages">
                                                    {{'paginateNext' | translate }}
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="overlay" tabindex="-1" role="dialog" *ngIf="isPopupVisible">
                <div class="modal-dialog popup" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{'popupBroadcastHeadingText' | translate }}</h5>
                        </div>
                        <form [formGroup]="createBroadcast" (ngSubmit)="onSubmit()">
                            <div class="popup-body modal-body">
                                <div class="form-group">
                                    <label for="broadcastType">{{'broadcastType' | translate }}:
                                        <span class="required-param">
                                            *
                                        </span>
                                    </label>
                                    <select name="broadcastType" id="broadcastType"
                                        class="form-control broadcast-type-field" formControlName="broadcastType">
                                        <option value="" disabled>{{'selectedOptionText' | translate }}</option>
                                        <option *ngFor="let receiver of broadcastReceivers"
                                            [value]="receiver.receiverId">
                                            {{ receiver.receiver }}
                                        </option>
                                    </select>
                                    <div class="error-block">
                                        <div
                                            *ngIf="createBroadcast.get('broadcastType')?.invalid && createBroadcast.get('broadcastType')?.touched">
                                            <small>
                                                {{'requiredBroadcastType' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="broadcastSubject">{{'broadcastSubjectText' | translate }}:
                                        <span class="required-param">
                                            *
                                        </span>
                                    </label>
                                    <input id="broadcastSubject" type="text" formControlName="broadcastSubject"
                                        placeholder="{{'broadcastSubject' | translate }}" (blur)="onBlur('broadcastSubject')" />
                                    <div class="error-block">
                                        <div
                                            *ngIf="createBroadcast.get('broadcastSubject')?.invalid && createBroadcast.get('broadcastSubject')?.touched">
                                            {{'requiredBroadcastSubject' | translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="broadcastMessage">{{'broadcastMessage' | translate }}:
                                        <span class="required-param">
                                            *
                                        </span>
                                    </label>
                                    <textarea id="broadcastMessage" name="broadcastMessage"
                                        class="broadcast-textarea-field" formControlName="broadcastMessage"
                                        placeholder="{{'broadcastMessagePlaceholder' | translate }}" rows="3"
                                        (blur)="onBlur('broadcastMessage')"></textarea>
                                    <div class="error-block">
                                        <div
                                            *ngIf="createBroadcast.get('broadcastMessage')?.invalid && createBroadcast.get('broadcastMessage')?.touched">
                                            <small>
                                                {{'broadcastMessagerequired' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group toogle-container">
                                    <label>{{'priority' | translate }}:</label>
                                    <label class="switch" id="priority">
                                        <input type="checkbox" formControlName="priority">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                                <div class="form-group attachment-container">
                                    <label>{{'attachmentLabel' | translate }}:</label>
                                    <input id="attachment" type="file" (change)="onFileChange($event)"
                                        accept="image/*,application/pdf" multiple #fileInput/>
                                    <div class="drag-drop-zone" 
                                         [class.drag-over]="isDragOver"
                                         (click)="openAttachmentPicker()"
                                         (dragover)="onDragOver($event)"
                                         (dragleave)="onDragLeave($event)"
                                         (drop)="onDrop($event)"
                                         *ngIf="attachments.length < 5">
                                        <div class="drag-drop-content">
                                            <i class="fas fa-cloud-upload-alt drag-drop-icon"></i>
                                            <p class="drag-drop-text">
                                                {{'dragDrop' | translate}} 
                                            </p>
                                            <small class="drag-drop-note">
                                                <strong>{{ 'attachementNoteText' | translate  }}:</strong>
                                                {{ 'attachmentNote' | translate  }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="file-preview-container" *ngIf="attachments.length > 0">
                                        <div class="file-preview-wrapper" *ngFor="let preview of previewUrls; let idx = index">
                                            <ng-container *ngIf="preview && attachments[idx]?.type?.startsWith('image/'); else documentPreview">
                                                <img [src]="preview" alt="Attachment Preview" class="file-preview" />
                                            </ng-container>
                                            <ng-template #documentPreview>
                                                <div class="document-preview">
                                                    <i class="fas fa-file-pdf" *ngIf="attachments[idx]?.type === 'application/pdf'"></i>
                                                    <i class="fas fa-file-alt" *ngIf="attachments[idx]?.type !== 'application/pdf'"></i>
                                                    <span>{{ attachments[idx]?.name }}</span>
                                                </div>
                                            </ng-template>
                                            <button type="button" class="preview-remove-btn" (click)="removeAttachment(idx)">
                                                <img class="remove-icon" src="../../assets/img/close.png" alt="remove attachment" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info"
                                    (click)="closePopup()" aria-label="Close"
                                    [disabled]="createBroadcastFormSubmit">{{'closebtnText' | translate }}</button>
                                <button type="submit" [disabled]="createBroadcast.invalid || createBroadcastFormSubmit"
                                    class="submit-btn btn btn-raised ink-reaction btn-info">
                                    <div *ngIf="createBroadcastFormSubmit;else submitText">
                                        <app-button-loader></app-button-loader>
                                    </div>
                                    <ng-template #submitText>{{ 'createText' | translate  }}</ng-template>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="overlay" tabindex="-1" role="dialog" *ngIf="mediaPreviewPopup">
                <div class="preview-img-container media-preview-container">
                    <div class="media-preview-panel">
                        <div class="close-preview-img-container">
                            <img src="../../assets/img/close.png" alt="close" (click)="closeMediaPreviewPopup()"
                                class="close-preview-image">
                        </div>
                        <h4 class="media-preview-heading">{{'previewLabel' | translate }}</h4>
                        <div class="media-preview-grid">
                            <div class="media-preview-card" *ngFor="let media of previewMediaList; let idx = index">
                                <ng-container *ngIf="isImageMedia(media.broadcastMediaType); else documentPreview">
                                    <img [src]="media.broadcastMediaUrl || media.broadcastMediaUrl" alt="preview"
                                        class="media-preview-thumbnail"
                                        (click)="openMedia(media.broadcastMediaUrl)">
                                </ng-container>
                                <ng-template #documentPreview>
                                    <button type="button" class="media-preview-doc-btn"
                                        (click)="openMedia(media.broadcastMediaUrl)">
                                        <i class="fas fa-file-pdf pdf-icon"
                                            *ngIf="media.broadcastMedisSubType?.toLowerCase() === 'pdf'; else otherDocIcon">
                                        </i>
                                        <ng-template #otherDocIcon>
                                            <i class="fas fa-file-alt pdf-icon"></i>
                                        </ng-template>
                                        <span class="media-preview-doc-text">
                                            {{ media.broadcastMedisSubType?.toUpperCase() || media.broadcastMediaType }}
                                        </span>
                                    </button>
                                </ng-template>
                                <p class="media-preview-label">
                                    {{ getMediaLabel(media, idx) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>